import type { CanvasArea } from '@mentimeter/editor-essentials/types';
import type { ModuleId } from '@mentimeter/http-clients';
import {
  PencilRulerIcon,
  PencilRulerSolidIcon,
  TextFormatIcon,
} from '@mentimeter/ragnar-visuals';
import { SLIDE_TYPE_ICON_MAP } from '@mentimeter/ragnar-visuals/slide-type-icons';

interface EditPaneIconProps {
  slideType: ModuleId;
  canvasArea: CanvasArea;
  isMobile: boolean;
  size: number;
}

export const EditPaneIcon = ({
  slideType,
  canvasArea,
  isMobile,
  size,
}: EditPaneIconProps) => {
  if (canvasArea === 'visualization') {
    const Icon = SLIDE_TYPE_ICON_MAP[slideType];
    return <Icon textColor="currentColor" isSmall />;
  }
  if (canvasArea === 'title') {
    return <TextFormatIcon aria-hidden={true} size={size} color="inherit" />;
  }

  const EditIcon = isMobile ? PencilRulerIcon : PencilRulerSolidIcon;

  return <EditIcon aria-hidden={true} size={size} color="inherit" />;
};
